import { createSlice } from '@reduxjs/toolkit';

const roleSlice = createSlice({
    name: 'role',
    initialState: {
        roleList: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        }, // For fetching all roles
        roleCreation: { data: null, loading: false, error: null }, // For creating a role
        roleUpdate: { data: null, loading: false, error: null }, // For updating a role
        roleDeletion: { data: null, loading: false, error: null }, // For deleting a role
    },
    reducers: {
        // Start actions
        fetchRolesStart: (state) => {
            state.roleList.loading = true;
            state.roleList.error = null;
        },
        createRoleStart: (state) => {
            state.roleCreation.loading = true;
            state.roleCreation.error = null;
        },
        updateRoleStart: (state) => {
            state.roleUpdate.loading = true;
            state.roleUpdate.error = null;
        },
        deleteRoleStart: (state) => {
            state.roleDeletion.loading = true;
            state.roleDeletion.error = null;
        },

        // Success actions
        fetchRolesSuccess: (state, action) => {
            state.roleList = { ...action.payload, loading: false };
        },
        createRoleSuccess: (state, action) => {
            state.roleCreation.loading = false;
            state.roleCreation.data = action.payload;
        },
        updateRoleSuccess: (state, action) => {
            state.roleUpdate.loading = false;
            state.roleUpdate.data = action.payload;
        },
        deleteRoleSuccess: (state, action) => {
            state.roleDeletion.loading = false;
            state.roleDeletion.data = action.payload;
        },

        // Fail actions
        fetchRolesFail: (state, action) => {
            state.roleList.loading = false;
            state.roleList.error = action.payload;
        },
        createRoleFail: (state, action) => {
            state.roleCreation.loading = false;
            state.roleCreation.error = action.payload;
        },
        updateRoleFail: (state, action) => {
            state.roleUpdate.loading = false;
            state.roleUpdate.error = action.payload;
        },
        deleteRoleFail: (state, action) => {
            state.roleDeletion.loading = false;
            state.roleDeletion.error = action.payload;
        },
    },
});

export const {
    fetchRolesStart,
    fetchRolesSuccess,
    fetchRolesFail,
    createRoleStart,
    createRoleSuccess,
    createRoleFail,
    updateRoleStart,
    updateRoleSuccess,
    updateRoleFail,
    deleteRoleStart,
    deleteRoleSuccess,
    deleteRoleFail,
} = roleSlice.actions;

export default roleSlice.reducer;